export default __webpack_public_path__ + "static/media/detail_mobile_11_2.675da48f.jpg";